import { render, staticRenderFns } from "./popupGuide.vue?vue&type=template&id=549f504d&"
import script from "./popupGuide.vue?vue&type=script&lang=js&"
export * from "./popupGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports